/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { RatioUnit } from './RatioUnit';
import {
    RatioUnitFromJSON,
    RatioUnitFromJSONTyped,
    RatioUnitToJSON,
} from './RatioUnit';

/**
 * 
 * @export
 * @interface Ratio
 */
export interface Ratio {
    /**
     * 
     * @type {number}
     * @memberof Ratio
     */
    value?: number;
    /**
     * 
     * @type {RatioUnit}
     * @memberof Ratio
     */
    unit?: RatioUnit;
    /**
     * 
     * @type {string}
     * @memberof Ratio
     */
    $type?: RatioTypeEnum;
}


/**
 * @export
 */
export const RatioTypeEnum = {
    UnitsNetSerializationJsonNetUnitsNetBaseJsonConverter1ValueUnitUnitsNetIQuantityPtwUnitsNetPtwUnitsNetSerializationJsonNet: 'UnitsNet.Serialization.JsonNet.UnitsNetBaseJsonConverter`1+ValueUnit[[UnitsNet.IQuantity, Ptw.UnitsNet]], Ptw.UnitsNet.Serialization.JsonNet'
} as const;
export type RatioTypeEnum = typeof RatioTypeEnum[keyof typeof RatioTypeEnum];



/**
 * Check if a given object implements the Ratio interface.
 */
export function instanceOfRatio(value?: unknown): value is Ratio {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(RatioTypeEnum)[0];
}

export function RatioFromJSON(json: any): Ratio {
    return RatioFromJSONTyped(json, false);
}

export function RatioFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ratio {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'unit': json['unit'] == null ? undefined : RatioUnitFromJSON(json['unit']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function RatioToJSON(value?: Ratio | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'value': value['value'],
        'unit': RatioUnitToJSON(value['unit']),
        '$type': value['$type'],
    });
}

